import { render, staticRenderFns } from "./feeComboManageList.vue?vue&type=template&id=1897a872&scoped=true"
import script from "./feeComboManageList.vue?vue&type=script&lang=js"
export * from "./feeComboManageList.vue?vue&type=script&lang=js"
import style0 from "./feeComboManageList.vue?vue&type=style&index=0&id=1897a872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1897a872",
  null
  
)

export default component.exports